// Base URL for the AgroLense API. Empty in local dev (Vite proxy handles
// /api/agro/*); set VITE_API_BASE for deployed builds (e.g.
// https://api.dev.agrolense.com — NOTE: deployed base has no /api/agro prefix).
const base = import.meta.env.VITE_API_BASE ?? ''
export const apiUrl = (path: string) => (base ? base + path.replace(/^\/api\/agro/, '') : path)
